import React from 'react'

import SurveyBrandDropdown from '.'
import { Loader } from 'shared/components/Loader'

/**
 * @param {object} props
 * @param {number} props.currentSurveyBrand
 * @param {function} props.onBrandChange
 * @param {object} props.surveyBrands
 */
export default function SurveyBrandDropdownContainer({
  currentSurveyBrand,
  onBrandChange,
  surveyBrands,
}) {
  function sortBrand(a, b) {
    return a.name - b.name
  }

  function toBrandDropdownOption(brandOptions) {
    brandOptions.sort(sortBrand)

    return brandOptions.map((option) => ({
      value: option.id,
      text: option.name,
      key: option.name,
    }))
  }

  function handleBrandChange(_, { value }) {
    onBrandChange(value)
  }

  if (!surveyBrands) {
    return <Loader />
  }

  const brandOptions = toBrandDropdownOption(surveyBrands.results)
  const defaultBrand = brandOptions.find((option) => option.value === currentSurveyBrand)

  return (
    <SurveyBrandDropdown
      defaultBrand={defaultBrand}
      brandOptions={brandOptions}
      onBrandChange={handleBrandChange}
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/SurveyBrandDropdown/container.js